// Vercel Functions（/api 配下）にJSONをPOSTする
export async function postJson(path, data) {
  const response = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error(`送信に失敗しました: ${response.status}`);
  }
  return response.json();
}
